// extracted by mini-css-extract-plugin
module.exports = {"base":"ServiceLogo_base__sECJ0","industry":"ServiceLogo_industry__8sTln"};